import React, { useEffect, useState } from "react";

const AnalogClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const minutes = String(time.getMinutes()).padStart(2, "0");
  const seconds = String(time.getSeconds()).padStart(2, "0");
  const ampm = time.getHours() >= 12 ? "PM" : "AM";
  const hours12 = String(time.getHours() % 12 || 12).padStart(2, "0");

  const dateStr = time.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #fafafa 0%, #f2f2f2 100%)",
      borderRadius: "14px",
      padding: "10px 18px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.9)",
      minWidth: "180px",
    }}>
      {/* Time row */}
      <div style={{ display: "flex", alignItems: "baseline", gap: "2px" }}>
        <span style={{
          fontSize: "32px",
          fontWeight: "700",
          color: "#444",
          letterSpacing: "2px",
          fontVariantNumeric: "tabular-nums",
          lineHeight: 1,
        }}>
          {hours12}:{minutes}
        </span>
        <span style={{
          fontSize: "14px",
          fontWeight: "600",
          color: "#888",
          marginLeft: "4px",
          letterSpacing: "1px",
          alignSelf: "flex-end",
          marginBottom: "3px",
        }}>
          {seconds}
        </span>
        <span style={{
          fontSize: "12px",
          fontWeight: "600",
          color: "#999",
          marginLeft: "4px",
          alignSelf: "flex-end",
          marginBottom: "4px",
        }}>
          {ampm}
        </span>
      </div>

      {/* Divider */}
      <div style={{
        width: "100%",
        height: "1px",
        background: "linear-gradient(to right, transparent, #bbb, transparent)",
        margin: "6px 0 5px",
      }} />

      {/* Date row */}
      <div style={{
        fontSize: "11px",
        color: "#888",
        fontWeight: "500",
        letterSpacing: "0.3px",
        textAlign: "center",
      }}>
        {dateStr}
      </div>
    </div>
  );
};

export default AnalogClock;
